<template>
  <div class="container">
    <br />
    <div class="jumbotron" v-if="formularioCarregado">
      <component
        v-if="formulario"
        :is="currentComponent"
        :formulario="formulario"
      ></component>
      <br />
      <hr />
      <div class="row" v-if="!formulario.ativo">
        <div class="col">
          <router-link :to="{ path: `/gerenciar-formulario` }">
            <button class="btn btn-outline-info btn-sm">
              Voltar para formulários
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="!formularioCarregado" class="alert alert-warning alert-block">
      Carregando formulario
    </div>
  </div>
</template>

<script>
//Tipos de formulário
import FormularioVotacao from "../components/Formularios/FormularioVotacao";
import FormularioPesquisa from "../components/Formularios/FormularioPesquisa";
import tipoFormulario from "../config/TipoFormulario";
import notificacaoService from "../services/Notificacao.service";
import storageService from "../services/storageService";

export default {
  name: "page-formulario",
  data() {
    return {
      currentComponent: ``,
    };
  },
  components: {
    FormularioVotacao,
    FormularioPesquisa,
  },
  computed: {
    formulario: function () {
      return this.$store.state.formulario;
    },
    pessoaId: function () {
      return this.$store.state.participante.pessoaId;
    },
    formularioCarregado() {
      return this.$store.getters.formularioCarregado;
    },
    formularioAssistido() {
      let { formularioAssistido: assistido } = this.$store.state;
      return assistido;
    },
  },
  methods: {
    exibirFormulario() {
      if (this.formulario.tipoFormularioId === tipoFormulario.VOTACAO) {
        this.currentComponent = FormularioVotacao;
      } else {
        this.currentComponent = FormularioPesquisa;
      }
    },
  },

  beforeMount() {
    this.$loading(true);

    const { formularioId, codigoCliente } = this.$route.params;
    if (formularioId > 0) {
      if (this.formularioAssistido) {
        const { pessoaId } = storageService.getCurrentParticipante();
        this.$store.dispatch("carregarFormularioAssistido", {
          formularioId,
          codigoCliente,
          pessoaId,
        });
      } else {
        this.$store.dispatch("carregarFormulario", {
          formularioId,
          codigoCliente,
        });
      }
    } else {
      notificacaoService.erro(
        "Não foi possível identificar o participante para responder ao formulário."
      );
    }
  },
  mounted() {
    //se exite formulario chamar
    this.formulario && this.exibirFormulario();

    if (this.formulario && !this.formulario.formularioId) {
      //const path = `/${this.$store.state.clienteFormulario.apelidoUnico}/area-logada/listagem-formulario`;
      //this.$router.push({path})
    }
  },
  updated() {
    const formularioCarregado = !this.$store.getters.formularioCarregado;
    this.$loading(formularioCarregado);
  },
};
</script>

<style>
/* @import url('../assets/gradiente.css'); */
body {
  background: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/View/FormularioPage.vue